export enum CessionType {
  FUND = 'FUND',
}

export interface BankAccount {
  id: string;
  bankName: string;
  accountNumber: string;
  accountType?: string;
}

export interface FundInfo {
  id: string;
  name: string;
  cost?: number;
}

export interface ResellDocument {
  id: string;
  documentId: string;
  folio: string;
  businessIdentifier: string;
  businessName: string;
  advance: number;
  amount: number;
  arrearRate: number;
  stakeholderIdentifier: string;
  stakeholderName: string;
  paymentDate: string;
  cessionDate: Date | string | null;
  tempStartDate: Date | string;
  startDate: Date | string;
  tempEndDate: Date | string;
  endDate: Date | string;
  operationCostFixed: number;
  operationCostVariable: number;
  rate: number;
  rateCost: number;
  originalAmount: number;
  fundId: string | null;
  fundName?: string;
  observation: string;
  days?: number;
  subType?: string;
  docType?: string;
  bankAccountReceiverId?: string;
  deleted: boolean;
  arrearsRate?: number;
  arrearTableId?: string;
  fund?: string;
  requestId?: string;
  requestType?: string;
  cessionStatus?: {
    isAccepted?: boolean;
    isProcessing?: boolean;
    isRejected?: boolean;
    isReceding?: boolean;
    isQuerySuccessful?: boolean;
    isLoading?: boolean;
    canRetry?: boolean;
    onRecede?: () => void;
    UrlAec?: string;
  };
}

export interface CessionDocument {
  id: string;
  businessName: string;
  businessIdentifier: string;
  folio: string;
  fundId: string | null;
  fundName?: string;
  amount?: number;
  stakeholderIdentifier?: string;
  stakeholderName?: string;
  paymentDate?: string;
  cessionDate: Date | string | null;
  originalAmount: number;
  advance: number;
  arrearRate: number;
  startDate: Date | string;
  endDate: Date | string;
  rate?: number;
  rateCost?: number;
  operationCostFixed?: number;
  operationCostVariable?: number;
  status?: boolean;
  message?: string;
  subType?: string;
  docType?: string;
}

export interface CessionDocumentPayload {
  id: string;
  folio: string;
  businessIdentifier: string;
  stakeholderIdentifier: string;
  amount: number;
  originalAmount: number;
  advance: number;
  arrearRate: number;
  subType: string;
  bankAccountId: number;
  cessionDate: Date;
  startDate: Date;
  endDate: Date;
  rate: string;
  rateCost: string;
  operationCostFixed?: string;
  operationCostVariable?: string;
  fund: FundInfo;
}

export interface FundCessionRequest {
  type: CessionType.FUND;
  documents: CessionDocumentPayload[];
  amountToReceive?: number;
  resellsToApply: {
    resellId: number;
    amount: number;
  }[];
}

// Props para el componente principal
export interface MultiResellMainProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  setUp: (pagination: { page: number; pageSize: number }) => Promise<void>;
  pagination: {
    page: number;
    pageSize: number;
    total: number;
    totalPages: number;
  };
}

// Props para el diálogo de cesión
export interface SimpleCessionDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  documents: CessionDocument[];
  bankAccountId: number;
  funds?: FundInfo[];
  amountToReceiveInput?: number;
  setUpMainPage: () => Promise<void>;
  resellsToApply: ResellSuggestedDocument[];
}

export interface ResellSuggestedDocument {
  id: number;
  documentFolio: string;
  dueDate: string;
  startDate: string;
  amount: number;
  netAmount: number;
  advance: number;
  businessName: string;
  stakeholderName: string;
  fundName: string;
  resellIsPaid: boolean;
  resellIsCompleted: boolean;
  resellHasFutureConciliations: boolean;
  documentAmountConciliated: number;
  arrearAmountConciliated: number;
  netAmountConciliated: number;
  documentAmountRemaining: number;
  arrearAmountRemaining: number;
  netAmountRemaining: number;
  amountToConciliate?: number;
}

export interface ApiResellResponse {
  documentId: string;
  folio: string;
  businessIdentifier: string;
  amount: number;
  originalAmount: number;
  stakeholderIdentifier: string;
  subType: string;
  docType: string;
  businessName: string;
  stakeholderName: string;
  paymentDate: string;
  requestId: string;
  requestType: string;
  cessionDate?: string;
}
